import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Logo } from '../../components/Logo.jsx';
import { MarketingFooter } from '../marketing/LandingPage.jsx';

/**
 * The frame both legal pages share.
 *
 * Rendered outside the app shell, readable signed in or out, and deliberately
 * plain: a legal page that needs a design to be read is a legal page nobody
 * reads. One column, generous line height, and a way back to where they came
 * from at the top.
 */
export function LegalShell({ title, updated, intro, children }) {
  return (
    <div className="flex min-h-screen flex-col" style={{ background: 'rgb(var(--surface))' }}>
      <header className="border-b" style={{ borderColor: 'rgb(var(--line))' }}>
        <div className="mx-auto flex h-16 w-full max-w-3xl items-center justify-between px-4 sm:px-6">
          <Link to="/" aria-label="DistrxPay home"><Logo size={26} /></Link>
          {/*
            * history.back() rather than a link to `/`: somebody who opened this
            * from the sign-up form wants to return to the sign-up form, not to
            * the top of the marketing page.
            */}
          <button type="button" onClick={() => window.history.back()} className="btn btn-ghost btn-sm">
            <ArrowLeft className="h-3.5 w-3.5" /> Back
          </button>
        </div>
      </header>

      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-12 sm:px-6 sm:py-16">
        <h1 className="text-[30px] font-semibold tracking-tight text-ink sm:text-[36px]">{title}</h1>
        <p className="mt-2 text-sm text-muted">Last updated: {updated}</p>
        {intro && <p className="legal-intro mt-6 text-[15px] leading-relaxed text-ink-soft">{intro}</p>}
        <div className="mt-10 space-y-10">{children}</div>
      </main>

      <MarketingFooter />

      <style>{`
        .legal-section p, .legal-section li {
          color: rgb(var(--ink-soft));
          font-size: 0.925rem;
          line-height: 1.75;
        }
        .legal-section p + p { margin-top: 0.75rem; }
        .legal-section ul {
          list-style: disc;
          padding-left: 1.4rem;
          margin: 0.75rem 0;
          display: grid;
          gap: 0.4rem;
        }
        .legal-link {
          color: rgb(var(--accent-ink));
          text-decoration: underline;
          text-underline-offset: 2px;
        }
        .legal-link:hover { color: rgb(var(--ink)); }
      `}</style>
    </div>
  );
}

export function LegalSection({ n, title, children }) {
  return (
    <section className="legal-section">
      <h2 className="mb-3 text-[17px] font-semibold tracking-tight text-ink">{n}. {title}</h2>
      {children}
    </section>
  );
}

export default LegalShell;
